<template>
  <div>
    <div class="line-three">
      <div class="flex three-class">
        <div class="icon-circle flex-x-y-center">
          <div class="iconfont icon-yonghu icons"></div>
        </div>
        <div>
          <div class="my-pro">人像验证</div>
        </div>
        <div class="flex-1">
          <div class="flex-end change-password" @click="uploadMyphotos">
            上传本人照片
          </div>
        </div>
      </div>
    </div>
    <div class="line"></div>
    <el-dialog
      title="请用手机浏览器扫描二维码，进行人像认证"
      :visible.sync="uploadMyphoto"
      width="40%"
    >
      <div class="flex-x-center">
        <div>
          <img class="my-photo-bacicle " src="@/assets/load.jpeg" alt="" />
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="uploadMyphoto = false">取 消</el-button>
        <el-button type="primary" @click="uploadMyphoto = false"
          >查询认证结果</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { encryptedPhone } from "@/api";
export default {
  data() {
    return {
      uploadMyphoto: false,
    };
  },
  methods: {
    uploadMyphotos() {
      this.uploadMyphoto = true;
    },
  },
  props: {
    // 流程
  },
};
</script>

<style scoped>
</style>
